<template>
  <v-container fluid>
    <v-sheet class="mx-auto">
      <v-slide-group multiple show-arrows>
        <v-slide-item> </v-slide-item>
      </v-slide-group>
    </v-sheet>


    <v-data-table v-model="selected" class="pt-3" show-select flat :loading="loading ? '#0482fb' : null"
      :headers="Avenantheaders" :items="ContractsList" :items-per-page="5" item-key="_id" sort-by="">
      <template v-slot:top>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date encaissement prime début" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="primeRepaymentDateStart" type="date" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date encaissement prime fin" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="primeRepaymentEndDate" type="date" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete outlined :items="userFile" class="pt-5 pa-2 " prepend-inner-icon="mdi-magnify"
                      v-model="fileName" dense flat background-color="grey lighten-4" label="Nom / Raison Sociale ...">
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="product" flat background-color="grey lighten-4" label="Produit"></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Police ..." class="pt-5 pa-2"
                      v-model="policeNumber" prepend-inner-icon="mdi-magnify" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date reversement prime début" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="companyRepaymentStartDate" type="date" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date reversement prime fin" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="companyRepaymentEndDate" type="date" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Emission ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="emissionNumber" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">

                    <v-text-field outlined color="#0482fb" label="Numéro Quittance ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="receiptNumber" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Cleint ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="customerNumber" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                </v-row>
                <v-card-actions>
                  <v-btn class="red--text mr-2" outlined color="red" pill @click="cleanOnEnter">

                    Effacer
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="#0482fb" pill class="white--text mr-2" @click="onEnter">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
        <v-toolbar flat>
          <h4 class="text-h4 pageTitle ">Liste des opérations en attente d'encaissement commission</h4>

          <v-divider class="mx-4" inset vertical></v-divider>
          <h4 class="text-h4 pageTitle">{{ selected.length ? selected.length : 0 }} sélections</h4>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-switch v-model="showAllFil" label="Afficher toutes les données" color="#0482fb" @change="showAllFillData"
            class="pt-5"></v-switch>
        </v-toolbar>
        <v-btn color="#0482fb" dark class="mt-5 ml-5 mb-10" @click="applyEncaissementModal()">
          Encaisser la sélection
        </v-btn>

      </template>
      <template v-slot:item.name="{ item }">
        <td>
          {{ item.file.name }}
        </td>
      </template>


      <template v-slot:item.actions="{ item }">
        <v-menu elevation="0" right offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
              <v-icon color="success" size="30">mdi-forwardburger</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-tooltip bottom color="warning">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="editContract(item)" v-bind="attrs" v-on="on"
                    color="warning">mdi-pencil-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Modification du contrat sélectionné</span>
            </v-tooltip>
            <!-- <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" color="success" v-bind="attrs" v-on="on"
                    @click="editContractCollection(item)">mdi-checkbox-marked-circle-plus-outline</v-icon>
                </v-btn>
              </template>
              <span>Encaissement de la commission</span>
            </v-tooltip> -->
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="handleClickMailGedQuitance(item)" color="success" v-bind="attrs" v-on="on">
                    mdi-file-document-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Gestion des fichiers quittance </span>
            </v-tooltip>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="handleClickMailGed(item)" color="success" v-bind="attrs" v-on="on">
                    mdi-file-document-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Gestion des fichiers reversement </span>
            </v-tooltip>
            <!-- <v-tooltip bottom color="black">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="handleClickFacture(item)" color="black" v-bind="attrs" v-on="on">
                    mdi-cash-register</v-icon>
                </v-btn>
              </template>
              <span>Facture</span>
            </v-tooltip> -->
          </v-list>
        </v-menu>
      </template>
    </v-data-table>


    <!--  Pop up add file-->
    <v-dialog v-model="fileDialog" overlay transition="dialog-bottom-transition" scrollable max-width="1000px">
      <v-card style="border-top:10px solid #0482fb" tile>
        <v-card-text>
          <h2 class="pt-8 pl-3">
            Signature de contrat
          </h2>

          <v-container fluid>
            <v-row align="center">
              <!-- <v-col cols="6">
                <v-select outlined 
                  :items="companyNameList"
                  v-model="contractModal.company"
                  label="Compagnie sélectionnée"
                  
                ></v-select>
              </v-col> -->
              <v-col cols="12" sm="3">
                <v-select outlined :items="avenantList" v-model="contractModal.actionType" label="Avenant"></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="contractModal.policeNumber"
                  label="Numero de police"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="contractModal.plugged"
                  label="Numéro avenant"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-select outlined :items="categorie" v-model="contractModal.category" label="Catégorie"></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" @change="ttcAutomatise()" v-model="contractModal.netPrime"
                  label="Prime nette"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" @change="ttcAutomatise()" v-model="contractModal.accessory100"
                  @blur="seed50Accessory" label="Coût de police"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined @change="ttcAutomatise()" color="#0482fb" v-model="contractModal.cdeaoPrime"
                  label="TAXE"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="contractModal.totalPrime" type="number"
                  label="Prime TTC"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="contractModal.primeRC" label="Prime RC"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="contractModal.accessory50" type="number"
                  label="Cout total police pour 50" disabled></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="contractModal.effectDate" type="date"
                  label="Effect"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="contractModal.dueDate" type="date"
                  label="Echeance"></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" v-model="contractModal.TACAVA" label="FGA"></v-text-field>
              </v-col> -->

              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="contractModal.commissionRate" type="number"
                  label="Taux commission" @change="ttcAutomatise()" suffix="%"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="contractModal.commission" type="number"
                  label="Commission"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" @change="ttcAutomatise()"
                  v-model="contractModal.managerCommissionRate" type="number" label="Taux commission de gestion"
                  suffix="%"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="contractModal.managerCommission" type="number"
                  label="Commission de gestion"></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" v-model="contractModal.TVA" label="CEDEAO"></v-text-field>
              </v-col> -->
              <!-- <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" disabled v-model="contractModal.commissionTTC"
                  label="Commission TTC"></v-text-field>
              </v-col> -->
              <v-col cols="12">
                <v-row justify="space-around">
                  <v-checkbox disabled v-model="contractModal.haveRegulationClause">
                    <template v-slot:label>
                      <div>Clause de régularisation</div>
                    </template>
                  </v-checkbox>

                  <v-checkbox disabled v-model="contractModal.havePbClause">
                    <template v-slot:label>
                      <div>Clause de PB</div>
                    </template>
                  </v-checkbox>

                  <v-checkbox disabled v-model="contractModal.haveCoinsurance">
                    <template v-slot:label>
                      <div>Coassurance</div>
                    </template>
                  </v-checkbox>

                  <v-checkbox disabled v-model="contractModal.haveReinsurance">
                    <template v-slot:label>
                      <div>Réassurance</div>
                    </template>
                  </v-checkbox>
                </v-row>
              </v-col>

              <v-col cols="12" md="6">
                <v-textarea outlined name="input-7-4" label="Observation contrat" v-model="contractModal.observation"
                  value=""></v-textarea>
              </v-col>

              <v-col cols="12" md="6">
                <v-textarea outlined name="input-7-4" label="Motif Impayé (Actions menées)"
                  v-model="contractModal.notPayedObservation" value=""></v-textarea>
              </v-col>

              <v-row justify="end">
                <v-btn color="error" text @click="closeContract">
                  Fermer
                </v-btn>

                <v-btn class=" ml-5 success white--text" :loading="loading ? '#0482fb' : null" @click="saveContract">
                  Enregistrer
                </v-btn>
              </v-row>
            </v-row>
          </v-container>
        </v-card-text>

        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
    <!-- factue contrat -->
    <v-dialog transition="dialog-bottom-transition" max-width="500" overlay v-model="factureDialog">
      <v-card style="border-top:10px solid red">
        <v-card-title>Imprimer une facture</v-card-title>
        <v-card-text>
          <div class=" pt-6 ">

            <v-autocomplete outlined :items="['DOIT', 'AVOIR']" color="#0482fb" class=""
              prepend-inner-icon="mdi-nature-people" v-model="invoiceInformation.invoiceNature" dense flat
              background-color="grey lighten-4" label="Nature de facture">
            </v-autocomplete>

          </div>
        </v-card-text>
        <v-card-actions class="justify-end pb-6">
          <!-- <v-btn text @click="(cancelDialog = false), (cancelModal = {})">Annuler</v-btn> -->
          <v-btn color="success" class="white--text" block @click="printSimpleFacture('simple')">Imprimer Facture
          </v-btn>
          <!-- <v-spacer></v-spacer>
          <v-btn color="success" class="white--text" @click="printSimpleFacture('PROFORMA')">Imprimé Facture Proforma
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Etes vous sûrs de vouloire supprimer cet élément ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Encaissement dialoge-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="contractDialog" max-width="1000px">
          <v-form ref="form" lazy-validation>
            <v-card style="border-top: 10px solid #0482fb">
              <v-card-title>
                <span class="text-h5">Générer commission</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-select outlined disabled :items="items" background-color="#cbf3f0" color="#0482fb"
                        label="Mode de paiement" :rules="[(v) => !!v || 'Mode de paiement non rempli']"
                        v-model="contractModal.paymentMethod"></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field outlined color="#0482fb" v-model="contractModal.commission" required disabled
                        :rules="[(v) => !!v || 'Commission est requise']" label="Commission"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field outlined color="#0482fb" label="Date d'encaissement"
                        v-model="contractModal.paymentDate" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field outlined color="#0482fb" background-color="#cbf3f0"
                        label="Numéro courrier arrivé (preuve)" v-model="contractModal.mailNumberPayement"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field outlined color="#0482fb" label="Taux commission"
                        v-model="contractModal.commissionRate" type="number" disabled suffix="%"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field outlined color="#0482fb" label="Numéro de quittance"
                        v-model="contractModal.receiptNumber" disabled></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error " text @click="closeContract">
                  Fermer
                </v-btn>
                <v-btn color="success " :loading="loading ? '#0482fb' : null" class="ml-5" @click="cashIn">
                  Encaisser
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-row>
      <v-dialog v-model="addFileMailGedQuittance" max-width="900px">
        <v-card style="border-top: 10px solid #0482fb">
          <v-card-title>
            <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier
              Quittance</span>
          </v-card-title>
          <v-item-group multiple>
            <v-container>
              <!-- {{filesListe}} -->
              <v-row>
                <v-col v-for="n in filesListeQuitance" :key="n" cols="12" md="4">
                  <v-item>
                    <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                      <v-card-text style="height: 100px; position: relative">
                        <h4 style="text-align: center;">
                          {{ n.filename }}
                        </h4>
                        <v-fab-transition>
                          <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                            route bottom right fab>
                            <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                          </v-btn>
                        </v-fab-transition>
                      </v-card-text>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
        </v-card>
      </v-dialog>
      <v-dialog transition="dialog-bottom-transition" max-width="800" overlay v-model="cancelDialog">
        <v-card style="border-top:10px solid red">
          <v-card-title>
            <span class="text-h5 mb-5 mt-5" style="color:#3A1C71;">Encaissement des dossiers sélectionnés</span>
          </v-card-title>
          <v-card-text>
            <v-row>

              <v-col cols="12" md="6">
                <v-text-field outlined color="#0482fb" background-color="#cbf3f0" label="Date d'encaissement"
                  v-model="contractModal.paymentDate" disabled></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field outlined color="#0482fb" background-color="#cbf3f0" label="Numéro courrier arrivé (preuve)"
                  v-model="contractModal.mailNumberPayement"></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="6">
                <v-text-field outlined color="#0482fb" background-color="#cbf3f0"
                  v-model="contractModal.mailNumberPayement" label="Date reversement compagnie"></v-text-field>
              </v-col> -->

              <!-- <v-col cols="12" sm="6" md="4">
              <v-text-field outlined color="#0482fb" background-color="#cbf3f0"
                v-model="reversementData.mailNumberReversement" label="Banque"></v-text-field>
            </v-col> -->
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="(cancelDialog = false), (cancelModal = {})">Annuler</v-btn>
            <v-btn color="error" class="white--text" @click="cashIn()">Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="addFileMailGed" max-width="900px">
        <v-card style="border-top: 10px solid #0482fb">
          <v-card-title>
            <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier
              reversement</span>
          </v-card-title>
          <v-item-group multiple>
            <v-container>
              <!-- {{filesListe}} -->
              <v-row>
                <v-col v-for="n in filesListe" :key="n" cols="12" md="4">
                  <v-item>
                    <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                      <v-card-text style="height: 100px; position: relative">
                        <h4 style="text-align: center;">
                          {{ n.filename }}
                        </h4>
                        <v-fab-transition>
                          <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                            route bottom right fab>
                            <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                          </v-btn>
                        </v-fab-transition>
                      </v-card-text>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
        </v-card>
      </v-dialog>
      <v-dialog v-model="Shodialog" max-width="490">
        <v-card class="pt-5" style="text-align:center,">
          <v-card-text>{{ testAlert }} </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages, rules } from "@/utils/data";
import { addFile, updateFile } from "@/api/admin";

import { updateContract } from "@/api/user";

export default {
  name: "production",
  components: {},
  data: () => ({
    panel: [],
    switch1: true,
    addFileMailGed: false,
    addFileMailGedQuittance: false,
    tab: null,
    perssonel: [],
    garantietitre: [
      {
        tab: "RESPONSABILITE CIVILE CHEF D'ENTREPRISE",
        content: "Tab 1 Content",
      },
      { tab: "MULTIRISQUE PROFESSIONNELLE", content: "Tab 2 Content" },
      { tab: "GLOBAL DE BANQUE BOA", content: "Tab 3 Content" },
      { tab: "MULTIRISQUE HABITATION", content: "Tab 4 Content" },
      { tab: "TRC", content: "Tab 5 Content" },
      { tab: "IND", content: "Tab 6 Content" },
    ],
    items: ["Espèces", "Chèque", "Virement", "Avoir"],
    natureprospect: ["Physics", "Entreprise"],
    focus: "",
    events: [],
    type: "month",
    selected: {},
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    Shodialog: false,
    colors: ["red"],
    names: ["Appel"],
    filesListe: [],
    filesListeQuitance: [],
    filesListePayement: [],
    colorss: ["green"],
    namess: ["Rendez vous"],
    categories: ["John Smith"],
    addgarantie: false,
    dialog: false,
    fileDialog: false,
    categorie: [],
    invoiceInformation: {
      invoiceNature: "",
      invoiceContractId: "",
    },
    factureDialog: false,
    contractDialog: false,
    appels: false,
    newappel: false,

    rdv: false,
    produit: false,
    cotation: false,
    garantie: false,
    contrat: false,
    notifications: false,
    sound: true,
    widgets: false,
    testAlert: "",
    prospect: false,
    dialogDelete: false,
    categoriegarantie: [
      {
        titreCatégorie: "I- Responsabilité Civile Exploitation",
        value1: "",
        value2: "",
        Souscategoriegarantie: [
          {
            titreCatégorie: "domage",
            value1: "",
            value2: "",
          },
          {
            titreCatégorie: "domage",
            value1: "",
            value2: "",
          },
        ],
      },
      {
        titreCatégorie: "II- Responsabilité Civile Professionnelle",
        value1: "",
        value2: "",
        Souscategoriegarantie: [
          {
            titreCatégorie: "Domage1",
            value1: "",
            value2: "",
          },
        ],
      },
      {
        titreCatégorie: "III- Défense et Recours",
        value1: "10 000 000",
        value2: "Néant",
      },
    ],
    produitsugest: [
      {
        text: " Liste des produits",
        value: "name",
      },
    ],
    Avenantheaders: [
      {
        text: "Actions",
        width: "150px",
        align: "left",
        value: "actions",
        sortable: false,
      },
      {
        text: "Date Opération",
        width: "200px",
        align: "start",
        sortable: false,
        value: "createdAtFr",
      },
      {
        text: "Date Encaissement",
        width: "200px",
        align: "start",
        sortable: false,
        value: "primeRepaymentDate",
      },
      {
        text: "Date Reversement",
        width: "200px",
        align: "start",
        sortable: false,
        value: "companyRepaymentDate",
      },
      { text: "Nom / Raison sociale", width: "200px", value: "name" },
      { text: "Mode de paiement", width: "200px", value: "paymentMethod" },
      { text: "Numéro chèque", width: "200px", value: "checkNumber" },
      { text: "Banque", width: "200px", value: "bank" },
      { text: "Branche", width: "200px", value: "product" },
      { text: "Type avenant", width: "200px", value: "actionType" },
      { text: "Numéro Police", width: "200px", value: "policeNumber" },
      { text: "Effet", width: "200px", value: "effectDateFr" },
      { text: "Echéance", width: "200px", value: "dueDateFr" },
      { text: "Prime nette", width: "200px", value: "netPrime" },
    ],
    produittake: [
      {
        text: "Liste des produits Proposer",
        value: "nom",
      },
    ],
    headers: [
      {
        text: "Nom / Raison Sociale",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Nature", value: "nature" },
      // { text: "Description", value: "description" },
      { text: "Domaine d'activité", value: "activityField" },
      { text: "Mail", value: "email" },
      { text: "Téléphone", value: "phone" },
      { text: "Date d'aniversaire", value: "birthday" },
      { text: "Localité", value: "location" },
    ],
    listproduit: [
      {
        name: "Cart d'identité",
      },
      {
        name: "permis de conduit",
      },
      {
        name: "Atestation de residence",
      },
    ],
    prospectdata: [],
    productNameList: [],
    editedIndex: -1,
    cancelDialog: false,
    contractModal: {},
    defaultItem: {
      nom: "",
      Nature: "",
      Contact: "",
      Activité: "",
      Mail: "",
      Anniverssaire: "",
      Localisation: "",
    },
    email: "",
    name: "",
    contact: "",
    birthday: "",
    emailRules: [
      (v) => !!v || "E-mail is ",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    loader: false,
    loading: false,
    rules,
    avenantList: [
      "Affaire Nouvelle",
      "Renouvellement",
      "Incorporation",
      "Retrait",
      "Suspension",
      "Remise en vigeur",
      "Precision",
      "Modification",
      "Resiliation",
      "Régularisation",
      "Prorogation",
      "Ajustement",
      "Saturation",
      "Changement d'immatriculation",
    ],
    companyNameList: [],
  }),

  mounted() {
    this.initContracts();
    // this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters(["ContractsList", "Companies", "Products", "Files"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Ajouter Dossier Production"
        : "Modifier Dossier Production ";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    Companies() {
      //alert('ok')
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);

      // this.seedCoinsuranceCompanyNameList();
    },
    Files() {
      this.userFile = defaultMethods.getNameList(this.Files.docs);
    },
    Products() {
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
    selected() {
      localStorage.setItem("commissionSelection", JSON.stringify(this.selected));
      // alert(JSON.stringify())
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions([
      "getContracts",
      "getCompanies",
      "postSearchEncaissement",
      "getProducts",
      "getFiles",
      "getDocFactureCommission"
    ]),
    initialize() { },
    closeForm() {
      this.contractModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = false;
      this.dialogDelete = false;

      this.editedIndex = -1;
    },
    ttcAutomatise() {
      // alert(this.modal.accessory100)
      this.contractModal.totalPrime = Number(this.contractModal.cdeaoPrime) + Number(this.contractModal.netPrime) + Number(this.contractModal.accessory100)
      // alert(this.companyReturncontractModal.TTCPrime)
      this.contractModal.commission = (Number(this.contractModal.netPrime) * Number(this.contractModal.commissionRate)) / 100
      this.contractModal.managerCommission = (Number(this.contractModal.netPrime) * Number(this.contractModal.managerCommissionRate)) / 100
    },
    showAllFillData() {
      this.initContracts();
      //alert(this.showAllFil);
    },
    handleClickFacture(item) {
      // console.log(item)
      this.invoiceInformation.invoiceContractId = item._id
      this.factureDialog = true
    },
    async printSimpleFacture(item) {
      // alert(item)
      const schema = {
        invoiceNature: this.invoiceInformation.invoiceNature,
        type: item
      }
      await this.getDocFactureCommission(
        { schema, id: this.invoiceInformation.invoiceContractId, });
      defaultMethods.dispatchSuccess(
        this.$store,
        messages.canceledSuccessfully("Ce contrat")
      );
    },
    async makeSearchContract() {
      this.loading = true;
      try {
        await this.postSearchEncaissement({
          fileName: defaultMethods.getItemId(this.Files.docs, this.fileName),
          product: this.product,
          policeNumber: this.policeNumber,
          plugged: this.plugged,
          companyRepaymentStartDate: this.companyRepaymentStartDate,
          companyRepaymentEndDate: this.companyRepaymentEndDate,
          primeRepaymentDateStart: this.primeRepaymentDateStart,
          primeRepaymentEndDate: this.primeRepaymentEndDate,
          customerNumber: this.customerNumber,
          receiptNumber: this.receiptNumber,
          company: this.company,
          emissionNumber: this.emissionNumber,
          periodStartDate: "",
          periodEndDate: "",
          notPayed: true,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    onEnter: function () {
      if (
        this.primeRepaymentDateStart == undefined &&
        this.primeRepaymentEndDate != undefined
      ) {
        this.testAlert = "";
        this.testAlert =
          "Date opération début requis pour la période de recherche";
        this.Shodialog = true;
      } else if (
        this.primeRepaymentEndDate == undefined &&
        this.primeRepaymentDateStart != undefined
      ) {
        this.testAlert = "";
        this.testAlert =
          "Date opération fin requise pour la période de recherche";
        this.Shodialog = true;
      } else if (
        this.primeRepaymentDateStart == undefined &&
        this.primeRepaymentEndDate == undefined
      ) {
        this.testAlert = "";
        this.testAlert = "Veuillez définir la période de recherche";
        this.Shodialog = true;
      } else {
        this.makeSearchContract();
      }
    },

    applyEncaissementModal() {
      // this.formatNumber(item);
      this.date_function();
      this.cancelDialog = true
    },
    async cleanOnEnter() {
      this.loading = true;
      this.primeRepaymentDateStart = ""
      this.primeRepaymentEndDate = ""
      this.fileName = ""
      this.product = ""
      this.policeNumber = ""
      this.companyRepaymentStartDate = ""
      this.companyRepaymentEndDate = ""
      this.emissionNumber = ""
      this.receiptNumber = ""
      this.customerNumber = ""
      await this.getContracts({
        notPayed: true,
        withoutPeriod: this.showAllFil,
        companyRepaymentDateExist: "true"
      });
      console.log(this.contractModal);
      this.selected = JSON.parse(localStorage.getItem("commissionSelection"))
      this.loading = false;
    },
    // Contracts
    async initContracts() {
      // alert("ok")
      this.loading = true;
      try {
        this.selected = {};
        await this.getContracts({
          notPayed: true,
          withoutPeriod: this.showAllFil,
          companyRepaymentDateExist: "true",
          sendToCommission: true,
        });
        console.log(this.contractModal);
        this.selected = JSON.parse(localStorage.getItem("commissionSelection"))
        await this.getFiles({ withoutPeriod: true });
        await this.getCompanies();
        await this.getProducts({ name: this.searchData });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    formatNumber(item) {
      item = Object.assign({}, item);
      item = defaultMethods.arrayFieldsToInteger(item);
      this.contractModal = Object.assign({}, item);
    },
    date_function: function () {
      var currentDate = new Date();
      console.log(currentDate);

      var formatted_date = new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "/");
      this.contractModal.paymentDate = formatted_date;
      // alert(this.contractModal.paymentDate)
    },
    editContractCollection() {
      //console.log(item);
      // this.formatNumber(item);
      this.date_function();
      //console.log(this.contractModal, "testOk");
      this.contractDialog = true;
    },
    async saveProspect() {
      this.loading = true;
      try {
        if (this.contractModal._id) {
          // update
          await updateFile({
            schema: {
              name: this.contractModal.name,
              prospects: this.contractModal.prospects,
              phone: this.contractModal.phone,
              email: this.contractModal.email,
              nature: this.contractModal.nature,
              location: this.contractModal.location,
              description: this.contractModal.description,
              activityField: this.contractModal.activityField,
              birthday: this.contractModal.birthday,
              // proposedProducts: this.contractModal.proposedProducts,
            },
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeForm();
          this.initContracts();
        } else {
          // add
          await addFile(this.contractModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Dossier")
          );
          this.closeForm();
          this.initContracts();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    async innCash() {
      this.loading = true;
      try {
        //this.$refs.form.validate();

        for (let index = 0; index < this.selected.length; index++) {
          const element = this.selected[index];
          // alert(element)

          try {
            const schema = {
              collectCommission: "true",
              paymentDate: this.contractModal.paymentDate,
              mailNumberPayement: this.contractModal.mailNumberPayement,
            }
            if (element._id) {
              // alert(element._id)
              await updateContract({
                schema,
                id: element._id,
              });
            }
          }
          catch (error) {
            defaultMethods.dispatchError(this.$store);
          }

        }
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Contract")
        );
        this.closeContract();
        this.initContracts();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
      finally {
        this.selected = {}
        window.localStorage.removeItem('commissionSelection');
        this.loading = false
      }
      // this.loading = false;
    },
    async cashIn() {

      this.innCash();

    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },
    addPersonnel() {
      this.contractModal.prospects.push({
        fullName: this.name,
        email: this.email,
        contact: this.contact,
        birthday: this.birthday,
      });

      this.initPersonnelForm();
    },
    initPersonnelForm() {
      this.name = "";
      this.email = "";
      this.contact = "";
      this.birthday = "";
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    handleClickMailGed(item) {
      this.filesListe = item.reversements_files;
      this.addFileMailGed = true;
    },
    handleClickMailGedQuitance(item) {
      this.filesListeQuitance = item.quittances_files;
      this.addFileMailGedQuittance = true;
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    async saveContract() {
      this.loading = true;
      try {
        const schema = {
          policeNumber: this.contractModal.policeNumber,
          plugged: this.contractModal.plugged,
          actionType: this.contractModal.actionType,
          category: this.contractModal.category,
          company: defaultMethods.getItemId(
            this.Companies.docs,
            this.contractModal.company
          ),
          TACAVA: this.contractModal.TACAVA,
          TE: this.contractModal.TE,
          TVA: this.contractModal.TVA,
          effectDate: this.contractModal.effectDate,
          dueDate: this.contractModal.dueDate,
          paymentDate: this.contractModal.paymentDate,
          netPrime: this.contractModal.netPrime,
          // commission: this.contractModal.commission,
          commissionRate: this.contractModal.commissionRate,
          primeRC: Number(this.contractModal.primeRC),
          collectionObservation: this.contractModal.collectionObservation,
          totalPrime: this.contractModal.totalPrime,
          cdeaoPrime: this.contractModal.cdeaoPrime,
          observation: this.contractModal.observation,
          accessory100: this.contractModal.accessory100,
          accessory50: this.contractModal.accessory100 / 2,
        };

        //  update
        await updateContract({
          schema,
          id: this.contractModal._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Contract")
        );
        this.closeContract();
        this.initContracts();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeContract() {
      this.contractDialog = false;
      this.fileDialog = false;
      this.cancelDialog = false;
      this.contractModal = {
        accessory100: 0,
        accessory50: 0,
      };
    },
    addProspect() {
      this.editedIndex = -1;
      this.contractModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = true;
    },
    editItemFormat(item) {
      item = defaultMethods.arrayFieldsToInteger(item);
      this.contractModal.totalPrime = item.totalPrime;
      this.contractModal.netPrime = item.netPrime;
      this.contractModal.cdeaoPrime = item.cdeaoPrime;
      this.contractModal.commission = item.commission;
      this.contractModal.accessory100 = item.accessory100;
      this.contractModal.accessory50 = item.accessory50;
    },
    editContract(item) {
      this.editedIndex = 1;
      this.contractModal = Object.assign({}, item);
      this.editItemFormat(item);
      this.contractModal.company = defaultMethods.getItemName(
        this.Companies.docs,
        this.contractModal.company
      );
      switch (this.contractModal.product) {
        case "BAOBAB +":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;
        case "DAYO KPELE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;
        case "ASSURANCE CREDIT":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;
        case "ASSURANCE CAUTION":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT BAIL":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "INDEMNITE DE FIN DE CARRIERE":
          {
            this.categorie = ["ASSURANCE DE PERSONNE"];
          }
          break;
        case "ASSURANCE SANTE":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "ASSURANCES TRANSPORTS":
          {
            this.categorie = [
              "CORP",
              "AERIEN",
              "TERRESTRE",
              "MARITIME",
              "FERROVIAIRE",
            ];
          }
          break;
        case "AUTOMOBILE":
          {
            this.categorie = [
              "FLOTTE AUTO",
              "FLOT MOTO",
              "MONO AUTO",
              "MONO MOTO",
            ];
          }
          break;
        case "BRIS DE MACHINE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "FAUX PAIEMENTS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "GLOBALE DE BANQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "GLOBALE DOMMAGES":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "INDIVIDUELLE ACCIDENTS":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;
        case "MULTIRISQUE HABITATION":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "MULTIRISQUE PROFESSIONNELLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "PREVOYANCE DECES":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;
        case "RC CHEF D'ENTREPRISE":
          {
            this.categorie = ["RESPONSABILITE CIVILE"];
          }
          break;
        case "RC CHEF DE FAMILLE":
          {
            this.categorie = ["RESPONSABILITE CIVILE"];
          }
          break;
        case "RC DECENNALE":
          {
            this.categorie = ["RESPONSABILITE CIVILE"];
          }
          break;
        case "RC EXPLOITATION":
          {
            this.categorie = ["RESPONSABILITE CIVILE"];
          }
          break;
        case "RC SCOLAIRE":
          {
            this.categorie = ["RESPONSABILITE CIVILE"];
          }
          break;
        case "RETRAITE COMPLEMENTAIRE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;
        case "TEMPORAIRE DECES":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;
        case "TOUS DOMMAGES SAUF":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "TOUS RISQUES MONTAGE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "TOUS RISQUES CHANTIER":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "TRAVEL ASSURANCE":
          {
            this.categorie = ["VOYAGE"];
          }
          break;
        case "VIOLENCE POLITIQUE":
          {
            //alert("ok");
            this.categorie = ["RESPONSABILITE CIVILE"];
          }
          break;
      }
      this.fileDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.contractModal = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.contractModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.contractModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.prospectdata[this.editedIndex], this.contractModal);
      } else {
        this.prospectdata.push(this.contractModal);
      }
      this.close();
    },
  },
};
</script>

<style scoped></style>
